import React, { useEffect, useRef, useState } from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import './carousel.css'; // Custom CSS for styling
import ArrowNew from "../../assets/Common/send.png"
import CardImg from "../../assets/CarouselImage/cardImage.png";
import { isMobile } from 'react-device-detect';
// import required modules
import { Pagination } from 'swiper/modules';
import { Dialog, DialogPanel, Transition, TransitionChild } from '@headlessui/react';
import { X } from 'react-bootstrap-icons';


const BenefitCarousel = ({ benefit, colors }) => { 
  // Function to handle scrolling to the specific section
  const [open, setOpen] = useState(false);
  const [popupData, setPopupData] = useState(null);  
  const sliderRef = useRef(null);
  const settings = {
    dots: isMobile ? false : benefit?.length > 3,
    dotsClass: "slick-dots",
    centerMode: false,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    draggable: isMobile ? true : benefit?.length > 3,
    swipe: isMobile ? true : benefit?.length > 3,
    customPaging: function(i) {
      return (
        <div
          style={{
            width: "10px",
            height: "10px",
            border: `1px solid ${colors?.textMuted}`,
            borderRadius: "50%",
            display: "inline-block",
            margin: "0 4px"
          }}
        />
      );
    },
    appendDots: dots => (
      <ul style={{ 
        margin: "0px",
        padding: "0px",
        position: "absolute",
        bottom: "-30px",
        textAlign: "center",
        width: "100%"
      }}> 
        {dots}
      </ul>
    ),
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1.4,
          slidesToScroll: 1,
        }
      }
    ]
  };

  // Add inline styles for active dots
  const customStyles = `
    .slick-dots li.slick-active div {
      background-color: ${colors?.secondary} !important;
    }
    .slick-dots li {
      margin: 0 !important;
    }
  `;
  
  return (
    <div className={`client ${(benefit?.length < 3 && !isMobile) ? 'benefit-parent' : ''} px-0 py-4 pb-16 lg:max-w-7xl mx-auto`}>
      <style>{customStyles}</style>
      <h1 style={{color: colors?.primary}} className='text-3xl text-left mb-4 font-semibold'>Benefits</h1>       
        <Slider ref={sliderRef} {...settings} className='w-full pb-10 max-sm:pb-0 max-sm:pt-0 text-left'>
          {benefit?.map((b_item, b_ind) => {
              return (
                <div key={b_ind} className="flex flex-col justify-between p-6 max-sm:p-4 border h-[250px] border-[#DBDBDB] rounded-xl">
                <div>
                  <h3 className="text-black text-[24px] max-sm:text-xl not-italic font-bold mb-2 leading-[120%]">
                    {b_item?.title}
                  </h3>
              
                  <p
                    className="line-clamp-4 text-base max-sm:text-sm not-italic font-normal leading-[140%]"
                    style={{ color: colors?.textMuted }}
                  >
                    {b_item?.description}
                  </p>
                </div>
              
                {b_item?.description?.length > 300 && (
                  <span
                    style={{ color: colors?.primary }}
                    onClick={() => {
                      setOpen(true);
                      setPopupData(b_item);
                    }}
                    className="cursor-pointer text-base not-italic font-normal leading-[140%] mt-2"
                  >
                    read more
                  </span>
                )}
              </div>              
              );
          })}
        </Slider>

      <Transition show={open}>
        <Dialog className="relative z-10" onClose={setOpen}>
          <TransitionChild
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </TransitionChild>

          <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <TransitionChild
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <DialogPanel className="relative transform overflow-hidden rounded-lg bg-[#fefefe] text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-xl">
                  <div className='bg-no-repeat p-8'>
                    <X className="absolute right-2 top-2 z-50 text-[#222] cursor-pointer text-2xl" onClick={() => setOpen(false)} />
                    <div className="rounded-xl">
                      <h3 className='text-black text-[24px] not-italic font-bold mb-2 leading-[120%]'>{ popupData?.title }</h3>
                      <p style={{color: colors?.textMuted}} className='text-base not-italic font-normal leading-[140%]'>{ popupData?.description }</p>
                    </div>
                  </div>
                </DialogPanel>
              </TransitionChild>
            </div>
          </div>
        </Dialog>
      </Transition>
    </div>
  );
};

export default BenefitCarousel;